import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextRegular } from 'UiKit/typography';
import InputTextAreaComponent from 'UiKit/input-textarea';

import styles from './styles.module.css';

const Reason = ({ form }) => {
  const { t } = useTranslation('host-reschedule');
  const { watch, register } = form;
  const { reason } = watch();

  return (
    <Box className={styles['reason__container']}>
      <Flex justifyContent={'space-between'}>
        <TextBold className={styles['reason__title-step-text']}>
          {t('reason.label')} <span>*</span>
        </TextBold>
        <TextRegular className={styles['reason-count__text']}>({reason.length}/160)</TextRegular>
      </Flex>

      <InputTextAreaComponent
        maxLength={160}
        minLength={5}
        register={{ ...register('reason') }}
        value={reason}
        placeholder={t('reason.placeholder')}
        textAreaClassName={styles['reason__input-textarea']}
      />
    </Box>
  );
};

export default Reason;
